import { Link } from "react-router-dom";

export function Logo({ compact = false }) {
  return (
    <Link className="brand" to="/" aria-label="Ecotimbre — accueil">
      <span className="brand__mark" aria-hidden="true"><span /></span>
      {!compact && <span className="brand__word">eco<span>timbre</span></span>}
    </Link>
  );
}
